import { Map } from 'immutable';
import { actionTypes } from './actions';
import initialState from './initialState';
import { createReducer } from 'utils/redux';

const onStart = () =>
  Map({
    loading: true,
    data: null,
    error: null,
  });

const onSuccess = (state, { payload }) =>
  Map({
    loading: false,
    data: payload,
    error: null,
  });

const onError = (state, { payload }) =>
  Map({
    loading: false,
    data: null,
    error: payload,
  });

export default createReducer(initialState, {
  [actionTypes.REQUEST_START]: onStart,
  [actionTypes.REQUEST_SUCCESS]: onSuccess,
  [actionTypes.REQUEST_FAILURE]: onError,
});
